import { render, staticRenderFns } from "./WelfareCentreOperationElderResidentsNumber.vue?vue&type=template&id=74673192&scoped=true&"
import script from "./WelfareCentreOperationElderResidentsNumber.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreOperationElderResidentsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74673192",
  null
  
)

export default component.exports